export const authPaths = {
    auth: {
      firebase: {
        login: `/auth/firebase/login`,
        verify: `/auth/firebase/verify`,
        register: `/auth/firebase/register`,
        forgotPassword: `/auth/firebase/forgot-password`,
      },
    },
  }